<div style="text-align: center;">
  <em class="far fa-check-circle fa-7x mx-1" style="color: #36B300;"></em>
  <h2>{{data.titulo}}</h2>
  <div mat-dialog-content class="my-2">{{data.pregunta}}</div>
</div>
